import { render, staticRenderFns } from "./timeCardTotals.vue?vue&type=template&id=610aec70&"
import script from "./timeCardTotals.vue?vue&type=script&lang=js&"
export * from "./timeCardTotals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports